<script>
import { BMediaAside } from "bootstrap-vue";

export default {
  extends: BMediaAside
};
</script>